<template>
  <div id="app">
    <router-view v-if="configDone"/>
    <qr-code v-if="initDone"></qr-code>
    <snapShot ref="snapShot"/>
  </div>
</template>
<script>
import url from "url"
import VConsole from 'vconsole'
import snapShot from "@/components/snapShot.vue"
import {
  mapMutations, mapState
} from 'vuex'
import {
  getConfigService,
} from '@/api'

const query = url.parse(window.location.href, true).query;

(['local', 'development'].includes(process.env.VUE_APP_WEB) ) && new VConsole()

export default {
  data () {
    return {
      curWechatUser: {},
      initDone: false,
      configDone: false
    }
  },
  computed: {
    ...mapState(['serviceConfig'])
  },
  components: {
    QrCode: () => import('@/components/qrcode/index.vue'),
    snapShot
  },
  async created() {
   try {
      const res = await getConfigService({key: (query && query.key) || 'wechat-common-jfql'})
      document.title = res.projectName
      this.configDone = true
      this.SET_SERVICE_CONFIG(res)
      this.$wechat.init(res)

    // 获取用户信息
    const userInfo = await this.getWechatUserByTempToken();

    // 如果没有 userInfo，说明已经跳转了，不再继续执行
    if (!userInfo) {
      return;
    }

     // 只有拿到用户信息后才继续执行
    await this.wechatReady();
     
    try {
      await this.wechatConfig();
      this.$wechat.onMenuShareTimeline({
        menuList: ['menuItem:copyUrl']
      })
      this.$store.commit('SET_WX_CONFIG_SUCCESS', true)
    } catch(err) {
      console.log("wechat init error: ",err)
    }
    this.initDone = true
   } catch(error) {
     console.error(`created error: ${JSON.stringify(error)}`);
   }
  },
  methods: {
    ...mapMutations(['SET_WECHAT_USER', 'SET_SERVICE_CONFIG']),
    async getWechatUserByTempToken() {
      this.curWechatUser = await this.$wechat.getUserInfoByTempToken();
      this.handleCurWechatUser();
      return this.curWechatUser;
    },
    async getWechatUser() {
      this.curWechatUser = await this.$wechat.getUserInfo(this.serviceConfig)
      this.handleCurWechatUser();
      return this.curWechatUser;
    },
    handleCurWechatUser() {
      if (this.curWechatUser) {
        // 进入快照模式
        if(this.curWechatUser.isSnapshotUser === 1){
          this.$refs.snapShot.open()
        }
        this.SET_WECHAT_USER(this.curWechatUser)
        this.$root.$emit('userReady')
        this.$behavior.init(Object.assign({}, this.curWechatUser, {
          project: this.serviceConfig.project,
          projectName: this.serviceConfig.projectName,
          channel: this.serviceConfig.channel,
        }))
        const userId = this.curWechatUser && this.curWechatUser.userId
        this.$sa.init(userId, this.curWechatUser, this.serviceConfig)
      } else {
        return false
      }
    },
    async wechatReady() {
       await this.$wechat.ready();
    },
    async wechatConfig() {
      await this.$wechat.config(() => {
          this.$store.commit('SET_WX_CONFIG_SUCCESS', true)
        }
      )
    }
  }
}
</script>

<style>
#app {
  -webkit-overflow-scrolling: touch;
  height: 100%;
  margin: 0 auto!important;
  background-color: #f2f2f2;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: url('./assets/loading.gif') no-repeat center;
  background-size: .8rem;
  z-index: 1;
  top: 0;
  background-color: #ffffff;
}

</style>
